module.exports = __webpack_public_path__ + "static/media/icon-popup-close.6be68813.svg";